export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);
export const EMPTY_FUNCTION: () => void = Object.freeze(() => {});
export const EMPTY_OBJECT: Readonly<Record<string, unknown>> = Object.freeze(
  {},
);
